import type { FC } from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Label } from "app/pages/industry-analysis/home/enriched-custom-industries/commonStyled";
import { minVisitsAbbrFilter } from "app/filters/ngFilters";
import { Container } from "app/pages/industry-analysis/home/enriched-custom-industries/TrafficAndEngagementData/commonStyled";

interface IVisits {
    visits?: number;
}

const { carbon } = colorsPalettes;

const Value = styled.span`
    ${setFontVariant("input2", carbon[500])};
    line-height: 24px;
`;

export const Visits: FC<IVisits> = (props) => {
    const { visits } = props;
    const i18n = i18nFilter();
    return (
        <Container>
            <Value>{minVisitsAbbrFilter()(visits)}</Value>
            <Label>{i18n("industry.research.homepage.benchmark.visits")}</Label>
        </Container>
    );
};
